// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { prepInterferenceParameterForAPI } from 'redux/modules/interferenceAnalysis/helpers'

const prepInterferenceParametersForAPI = ({ bands }) => (
  bands.map(band => (
    prepInterferenceParameterForAPI(band)
  ))
)

export default prepInterferenceParametersForAPI
